import { render } from "./browsingHistory.vue?vue&type=template&id=cf870404&scoped=true"
import script from "./browsingHistory.vue?vue&type=script&lang=js"
export * from "./browsingHistory.vue?vue&type=script&lang=js"

import "./browsingHistory.vue?vue&type=style&index=0&id=cf870404&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf870404"]])

export default __exports__